<template>
  <div style="border-bottom: 1px solid rgb(230, 230, 230);background-color: #fff;">
    <div style="width: 1300px; margin: auto;padding: 30px 0;">
      <div class="d_flex" style="height: 70px;align-items: center;padding: 0 0;">
        <div>
          <img  @click="toIndex" src="../../assets/img/topLog2.png" width="230px"/>
        </div>
        <div class="searchBlock d_flex">
          <input @keyup.enter="getAllList" placeholder="请输入品名 规格" v-model="keyWord" type="text" />
          <div class="c_p">
            <img @click="getAllList" style="height: 36px;width: 36px;" src="../../assets/img/search.png">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pubilshSet from '../../assets/js/pubilshSet'

export default {
  name: 'allTop',
  data () {
    return {
      keyWord: ''
    }
  },
  created () {
  },
  methods: {
    toIndex () {
      window.location.href = pubilshSet.searchHostUrl
    },
    getAllList () {
      if (this.keyWord) {
        this.$router.push({
          name: 'searchResult',
          query: {
            name: this.keyWord
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.searchBlock{
  width: 600px;
  height: 40px;
  border: 1px solid #D71E1E;
  border-radius: 4px;
}
.searchBlock input{
  flex: 1;
  height: 100%;
  border: none;
  border-radius: 4px 0px 0px 4px;
  padding: 0 10px;
}
.searchBlock div{
  padding-left: 10px;
  padding-right: 9px;
  height: 100%;
  background: #D71E1E;
  color: #fff;
  font-weight: bold;
  text-align: center;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/myComponents/headerSearch.vue